// The free read's admit-rate line, with its basis (#3529). preview_fit reads
// a resident on the school's in-state rate (fit_doors.residency_door), so a
// bare "25% acceptance rate" passed UC San Diego's in-state 25% off as the
// overall rate the rest of the app shows (28.6%). One wording for both read
// cards (Astra Lite's and the free read's).
const BASIS = { in_state: 'in-state ', out_of_state: 'out-of-state ', international: 'international ' };

export function rateLine(rate, basis) {
    return `${rate}% ${BASIS[basis] || ''}acceptance rate`;
}
